/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyResponse
 */
export interface ProxyResponse {
    /**
     * 
     * @type {number}
     * @memberof ProxyResponse
     */
    proxyId: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyResponse
     */
    proxyUrl: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProxyResponse
     */
    personas?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyResponse
     */
    proxyName?: string | null;
}

/**
 * Check if a given object implements the ProxyResponse interface.
 */
export function instanceOfProxyResponse(value: object): value is ProxyResponse {
    if (!('proxyId' in value) || value['proxyId'] === undefined) return false;
    if (!('proxyUrl' in value) || value['proxyUrl'] === undefined) return false;
    return true;
}

export function ProxyResponseFromJSON(json: any): ProxyResponse {
    return ProxyResponseFromJSONTyped(json, false);
}

export function ProxyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'proxyId': json['proxy_id'],
        'proxyUrl': json['proxy_url'],
        'personas': json['personas'] == null ? undefined : json['personas'],
        'proxyName': json['proxy_name'] == null ? undefined : json['proxy_name'],
    };
}

export function ProxyResponseToJSON(json: any): ProxyResponse {
    return ProxyResponseToJSONTyped(json, false);
}

export function ProxyResponseToJSONTyped(value?: ProxyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proxy_id': value['proxyId'],
        'proxy_url': value['proxyUrl'],
        'personas': value['personas'],
        'proxy_name': value['proxyName'],
    };
}

